import { NormCoverageDTO } from '../dashboardSceneDTO';
import IdListDTO from '../IdListDTO';

export class Widget70DTO {
  isoNormId?: number;

  tenants?: IdListDTO;

  coverages?: NormCoverageDTO[];
}
